import { Outlet } from "react-router-dom";

/**
 * Reading column for single-item detail routes (product/package/membership
 * pages, booking).
 *
 * These pages are one continuous narrative — hero, description, then a sticky
 * buy bar — so stretching them across a desktop viewport blows the hero up and
 * strands the copy. Capping the measure keeps them page-shaped without
 * rebuilding each detail screen.
 */
export const DetailColumnLayout = () => {
  return (
    <div className="mx-auto w-full desk:max-w-3xl">
      <Outlet />
    </div>
  );
};
